export default function CustomError({ errorType, status }) {
  this.errorType = errorType;
  this.status = status;
}

CustomError.prototype = Error.prototype;
